import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { Matcher, DateRange } from "react-day-picker";

import { Icons } from "../../../assets";
import { Calendar, PopoverRadix } from "../../atoms";
import * as s from "./styled-day-picker";

type TDatePicker = {
    value?: Date | DateRange;
    onSelect: (date?: Date | DateRange) => void;
    placeholder?: string;
    label?: string;
    error?: any;
    toYear?: number;
    icon?: React.ReactNode;
    disabled?: Matcher | Matcher[];
    height?: string;
    backgroundColor?: string;
    borderColor?: string;
    mode?: "single" | "range";
};

export default ({
    value,
    onSelect,
    placeholder,
    height,
    label,
    error,
    toYear,
    icon,
    disabled,
    backgroundColor,
    borderColor,
    mode = "single",
}: TDatePicker) => {
    return (
        <s.Container
            height={height}
            backgroundColor={backgroundColor}
            error={!!error}
            borderColor={borderColor}
        >
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                }}
            >
                <PopoverRadix
                    trigger={
                        <>
                            {label && <label className="label">{label}</label>}
                            <button
                                type="button"
                                className={`btn ${error ? "error" : ""}`}
                            >
                                {!value && (
                                    <p className="placeholder">{placeholder}</p>
                                )}
                                {value &&
                                    mode === "single" &&
                                    value instanceof Date &&
                                    format(value, "dd/MM/yyyy")}
                                {value &&
                                    mode === "range" &&
                                    !(value instanceof Date) &&
                                    value.from && (
                                        <span>
                                            {format(value.from, "dd/MM/yyyy")}
                                            {value.to &&
                                                ` - ${format(
                                                    value.to,
                                                    "dd/MM/yyyy"
                                                )}`}
                                        </span>
                                    )}
                                {icon || <Icons.CalendarOutline />}
                            </button>
                        </>
                    }
                >
                    <Calendar
                        selectedDay={value}
                        onChange={onSelect}
                        navigationMode="dropdown"
                        toYear={toYear}
                        disabled={disabled}
                        mode={mode}
                    />
                </PopoverRadix>

                {error && (
                    <Typography
                        variant="subtitle1"
                        sx={{
                            position: "absolute",
                            bottom: "-1.5rem",
                            fontSize: "0.75rem",
                            marginLeft: "0.875rem",
                            marginRight: "0.875rem",
                            color: "#d32f2f",
                        }}
                    >
                        {mode === "single" ? error.message : error.to.message}
                    </Typography>
                )}
            </Box>
        </s.Container>
    );
};
